import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import './ProcessNodes.css';

/**
 * Case Evidence Extractor node.
 *
 * Renders a process-builder canvas card for the `case_extractor` execution
 * type. Reads `data.case_extractor_config` for the LLM model badge.
 */
function CaseExtractorNode({ data, selected }) {
  const inputCount = data.inputs?.length || 0;
  const outputCount = data.outputs?.length || 0;
  const cfg = data.case_extractor_config || {};
  const model = cfg.llm_model || data.model || 'gpt-4o';

  return (
    <div className={`process-node case-extractor-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Left} className="node-handle input-handle" />

      <div className="node-header">
        <span className="node-icon">📑</span>
        <span className="node-type-badge case-extractor">CASE EXTRACTOR</span>
      </div>

      <div className="node-body">
        <div className="node-name">{data.name || 'Case Evidence Extractor'}</div>
        {data.description && (
          <div className="node-description">{data.description}</div>
        )}
      </div>

      <div className="node-footer">
        <div className="node-meta">
          <span className="meta-item">
            <span className="meta-icon">↓</span>
            {inputCount} input{inputCount !== 1 ? 's' : ''}
          </span>
          <span className="meta-item">
            <span className="meta-icon">↑</span>
            {outputCount} output{outputCount !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="node-model">{model}</div>
      </div>

      <Handle type="source" position={Position.Right} className="node-handle output-handle" />
    </div>
  );
}

export default memo(CaseExtractorNode);
